<template>
  <div class="data-panel-cube-wrapper" :class="{ 'close-setting-panel': !settingPanelShow }">
    <div class="data-panel-cube-header">
      <span v-show="settingPanelShow">数据</span>
      <i class="el-icon-s-unfold self-icon" @click="tabPanelCloseOrOpen"></i>
    </div>
    <div class="tree-wrapper">
      <template v-if="selectItem._id && settingPanelShow">
        <cube-query @preview-detail="previewDetail" :selectItem="selectItem"></cube-query>
        <el-input placeholder="请输入字段搜索" style="width:90%;margin:6px 5%" size="mini" v-model="dinFilterStr"></el-input>
        <div class="data-panel-tree-title">
          <span>维度</span>
          <!-- <i class="el-icon-warning-outline"></i> -->
        </div>
        <div class="data-panel-dimension-tree">
          <template>
            <el-collapse v-model="activeNames" v-if="selectItem.dataSetId">
              <el-collapse-item v-for="el in dimensionList" :title="el.name" :key="el.name" :name="el.name">
                <ul class="ui-schema-antd-tree">
                  <draggable filter=".isFilter" :sort="false" data-type="dimension" v-model="el.list"
                    :group="{ name: 'any', pull: 'clone', put: false }" animation="300">
                    <li class="drag-li" v-for="(i, index) in el.list" :key="`${i.id}_${index}`"
                      :class="{ isFilter: hasChildren(i) }">
                      <div class="field-tree-left">
                        <div class="field-tree-item-warp">
                          <i v-if="hasChildren(i)" class="el-icon-caret-right" :class="{ 'open-rotate': i.isOpen }"
                            @click="setOpenIcon(i)"></i>
                          <span class="field-tree-text" :title="i.name">{{ i.name }}</span>
                        </div>
                        <ul v-show="i.isOpen && hasChildren(i)">
                          <draggable v-model="i.children" data-type="dimension" :sort="false"
                            :group="{ name: 'any', pull: 'clone', put: false }" animation="300">
                            <li class="drag-li" v-for="(c, cIndex) in i.children" :key="`${c.id}_${cIndex}`">
                              <div class="field-tree-item-warp">
                                <span class="field-tree-text" :title="c.name">{{ c.name }}</span>
                              </div>
                            </li>
                          </draggable>
                        </ul>
                      </div>
                    </li>
                  </draggable>
                </ul>
              </el-collapse-item>
            </el-collapse>
            <ul class="ui-schema-antd-tree">
              <draggable :sort="false" data-type="dimension" v-model="dimensions"
                :group="{ name: 'any', pull: 'clone', put: false }" animation="300">
                <li class="drag-li" v-for="(i, index) in dimensions" :key="`${i.id}_${index}`"
                  :class="{ isFilter: hasChildren(i) }">
                  <div class="field-tree-left">
                    <div style="display: flex;align-items: center;">
                      <div class="field-tree-item-warp">
                        <i v-if="hasChildren(i)" class="el-icon-caret-right" :class="{ 'open-rotate': i.isOpen }"
                          @click="setOpenIcon(i)"></i>
                          <tip-icon :attrs="i.attrs"></tip-icon>
                        <span class="field-tree-text" :title="i.name">{{ i.name }}</span>
                      </div>
                    </div>
                    <ul v-show="i.isOpen && hasChildren(i)">
                      <draggable v-model="i.children" data-type="dimension" :sort="false"
                        :group="{ name: 'any', pull: 'clone', put: false }" animation="300">
                        <li class="drag-li" v-for="(c, cIndex) in i.children" :key="`${c.id}_${cIndex}`" style="padding-bottom: 0;">
                          <div class="field-tree-item-warp" style="display: flex;align-items: center;margin-bottom: 4px;">
                            <tip-icon :attrs="c.attrs"></tip-icon>
                            <span class="field-tree-text" style="margin-left: 4px;" :title="c.name">{{ c.name }}</span>
                          </div>
                        </li>
                      </draggable>
                    </ul>
                  </div>
                </li>
              </draggable>
            </ul>
          </template>
        </div>
        <div class="data-panel-tree-title">
          <span>度量</span>
          <!-- <i class="el-icon-warning-outline"></i> -->
        </div>
        <div class="data-panel-dimension-tree">
          <ul class="ui-schema-antd-tree">
            <draggable filter=".isFilter" data-type="measure" :sort="false" v-model="measures"
              :group="{ name: 'any', pull: 'clone', put: false }" animation="300">
              <li class="drag-li" v-for="i in measures" :key="i.id" :class="{ isFilter: hasChildren(i) }">
                <div class="field-tree-left">
                  <div style="display: flex;align-items: center;">
                    <div class="field-tree-item-warp">
                      <i v-if="hasChildren(i)" class="el-icon-caret-right" :class="{ 'open-rotate': i.isOpen }"
                        @click="setOpenIcon(i)"></i>
                        <tip-icon :attrs="i.attrs"></tip-icon>
                      <span class="field-tree-text" :title="i.name">{{ i.name }}</span>
                    </div>
                  </div>
                  <ul v-show="i.isOpen && hasChildren(i)">
                    <draggable v-model="i.children" data-type="measure" :sort="false"
                      :group="{ name: 'any', pull: 'clone', put: false }" animation="300">
                      <li class="drag-li" ghostClass="measure" v-for="c in i.children" :key="c.id">
                        <div class="field-tree-item-warp">
                          <span class="field-tree-text" :title="c.name">{{ c.name }}</span>
                        </div>
                      </li>
                    </draggable>
                  </ul>
                </div>
              </li>
            </draggable>
          </ul>
        </div>
      </template>
      <template v-if="!settingPanelShow">
        <div class="jzliu-bi-engine-vertical-text" @click="tabPanelCloseOrOpen">数据</div>
      </template>
    </div>
  </div>
</template>

<script>
import cubeQuery from './cubeQuery'
import draggable from 'vuedraggable'
// import { mapMutations, mapState } from 'vuex'
import { mockGetFactDetail } from '../mock/factDetail'
import tipIcon from './base/tipIcon.vue'
const _ = require('lodash')

export default {
  name: 'dataPanel',
  props: {
    selectItem: {
      type: Object,
      default: () => ({})
    },
    globalConfig: {
      type: Object,
      default: () => ({})
    }
  },
  components: { draggable, tipIcon, cubeQuery },
  data() {
    return {
      dimensions: [],
      dinFilterStr: '',
      dimensionList: [],
      activeNames: [],
      settingPanelShow: true,
      degenerationList: [],
    }
  },
  watch: {
    'dinFilterStr': {
      handler() {
        this.factChangePro()
      },
      deep: true,
    },
    'selectItem.dataSetId': {
      handler() {
        this.factChangePro()
      },
      deep: true,
    },
  },
  computed: {
    // ...mapState(['curPanelChart']),
    measures() {
      return this.listTransfer(this.selectItem.measures)
    },
    hasChildren() {
      return (item) => {
        return item.children?.length
      }
    },
  },
  // 移除 created 中的 $bus 监听，因为现在通过 props 传递
  methods: {
    previewDetail() {
      this.$emit('preview-detail', this.selectItem)
    },
    factChangePro() {
      const sourceDimensions = Array.isArray(this.selectItem.dimensions) ? this.selectItem.dimensions : []
      const keyword = (this.dinFilterStr || '').trim().toLowerCase()
      const filteredTree = this.filterDimensionTree(sourceDimensions, keyword)
      this.dimensions = this.listTransfer(filteredTree)
    },
    listTransfer(list = []) {
      if (!Array.isArray(list)) return []
      return list.map((v) => {
        const item = {
          ...v,
          id: v.unitCode,
          name: v.unitName,
        }
        if (Array.isArray(v.children) && v.children.length) {
          item.children = this.listTransfer(v.children)
        } else {
          item.children = []
        }
        return item
      })
    },
    filterDimensionTree(list = [], keyword = '') {
      if (!Array.isArray(list)) return []
      return list.reduce((acc, item) => {
        const children = this.filterDimensionTree(item.children || [], keyword)
        const selfMatch = !keyword || (item.unitName || '').toLowerCase().includes(keyword)
        if (selfMatch || children.length) {
          acc.push({
            ...item,
            children,
          })
        }
        return acc
      }, [])
    },
    // 事实表选择切换查询维度和度量信息
    async factChange() {
      try {
        const dimInfos = this.selectItem.dimensions
        const measureInfos = this.selectItem.measures
        console.log(dimInfos, measureInfos)
        const listTransfer = (list, listName) => {
          this[listName] = list.map((v) => {
            return {
              ...v,
              id: v.unitCode,
              name: v.unitName,
            }
          })
        }
        listTransfer(dimInfos, 'dimensions')
        listTransfer(measureInfos, 'measures')
        const dimensionGroup = _.groupBy(dimInfos, (n) => n['belongDimName'])
        this.dimensionList = []
        this.degenerationList = []
        this.activeNames = []
        for (let i in dimensionGroup) {
          let obj = {}
          obj.name = i
          obj.list = dimensionGroup[i]
          if (i == 'null') {
            this.degenerationList = obj.list
          } else {
            this.dimensionList.push(obj)
          }
        }
        console.log('aa:', this.degenerationList, this.dimensionList)
      } catch ( e) {
        console.log('e:',e)
      }
    },
    tabPanelCloseOrOpen() {
      this.settingPanelShow = !this.settingPanelShow
      this.globalConfig.dashboardDesignerWidth = this.globalConfig.dashboardDesignerWidth + (!this.settingPanelShow ? -140 : 140)
    },
    setOpenIcon(item) {
      this.$set(item, 'isOpen', !item.isOpen)
    },
  },
}
</script>

<style scoped lang="less">
.data-panel-cube-header {
  height: 48px;
  line-height: 48px;
  color: var(--bi-jz-font-color);
  font-size: 14px;
  padding: 0 12px;
  border-bottom: 1px solid var(--bi-jz-border-color);
  background-color: var(--bi-jz-bg-color);
  display: flex;
  justify-content: space-between;
}

.data-panel-cube-wrapper {
  border-left: 1px solid var(--bi-jz-border-color);
  background-color: var(--bi-jz-bg-color);
  z-index: 1;
  color: var(--bi-jz-font-color);
  width: 180px;
  max-width: 240px;
  position: relative;

  /* 暗色主题增强 */
  /deep/ .el-input__inner {
    background-color: var(--bi-jz-input-bg-color) !important;
    border-color: var(--bi-jz-input-border-color) !important;
    color: var(--bi-jz-input-color) !important;
  }

  /deep/ .el-input__inner::placeholder {
    color: #a8abb2 !important;
  }

  /deep/ .el-collapse-item {
    background-color: var(--bi-jz-bg-color);
  }

  /deep/ .el-collapse-item__header {
    padding: 0 0 0 16px;
    background: #081126;
    height: 32px;
    line-height: 32px;
    color: var(--bi-jz-font-color);
    font-size: 12px;
    border: none;
  }

  /deep/ .el-collapse-item__content {
    padding-bottom: 0;
  }

  /deep/ .el-collapse {
    border: none;
  }

  /deep/ .el-collapse-item__wrap {
    background-color: transparent;
    border: none;
  }

  .tree-wrapper {
    height: calc(100% - 88px);
    overflow: hidden;

    .data-panel-dimension-tree {
      border-bottom: 1px solid var(--bi-jz-border-color);
      height: 50%;
      overflow-y: auto;
    }

    .data-panel-tree-title {
      padding: 8px 12px;
      padding-bottom: 4px;
      display: flex;
      align-items: center;

      .el-icon-warning-outline {
        margin-left: 8px;
      }
    }
  }
}
</style>
